var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dam-layout',[_c('asset-listing',_vm._b({},'asset-listing',{items: _vm.items, categories: _vm.categories, collections: _vm.collections, meta_groups: _vm.meta_groups, meta_values: _vm.meta_values, types: _vm.types},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }